import React from "react";
import { Collapse, Radio, Icon } from "antd";

const Panel = Collapse.Panel;
const RadioGroup = Radio.Group;

export const SubCollapse = ({ t, title, consented, lawfulUsage }) => (

  <Collapse
    className="collapse-usage bg-transparent"
    bordered={false}
    expandIcon={({ isActive }) => (
      <Icon type="caret-right" rotate={isActive ? 90 : 0} />
    )}
  >
    <Panel className="sub-collapse-panel" header={title} key="1" style={{marginTop:  "5px"}}>
      <div className="group">
        <RadioGroup
          className="radio-group-small"
          disabled={true}
          defaultValue={consented ? "Allow" : "Disallow"}
          value={consented ? "Allow" : "Disallow"}
        >
          <Radio value={"Allow"}>{t("consent.allow")}</Radio>
          <Radio value={"Disallow"}>{t("consent.disallow")}</Radio>
        </RadioGroup>
      </div>
    </Panel>
  </Collapse>
);
